import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=4f873832&scoped=true"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"
import style0 from "./UserName.vue?vue&type=style&index=0&id=4f873832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f873832",
  null
  
)

export default component.exports